module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ordersuccess-container"
  }, [_c('header', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('MenuFooters', {
    attrs: {
      "isHide": _vm.isHide,
      "menuType": _vm.currentMenuType
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-data"
  }, [_c('span', {
    staticClass: "tipimg"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/success.png")
    }
  })]), _c('span', {
    staticClass: "tiptext"
  }, [_vm._v("您已成功预约，"), _c('br'), _vm._v("可用预约手机号登录"), _c('a', {
    attrs: {
      "href": "/#/my"
    }
  }, [_vm._v("我的")]), _vm._v("，查看确认")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-48842494"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderSuccess.vue
// module id = 193
// module chunks = 1